//Production is ikea.com latest and next/latest. Verification is CTE next/latest and PRs. Development is localhost. This matches the segments in DEXF Settings.
export var Environment;
(function (Environment) {
    Environment["PRODUCTION"] = "production";
    Environment["PRODUCTION_NEXT_LATEST"] = "production-next-latest";
    Environment["VERIFICATION"] = "verification";
    Environment["VERIFICATION_PR"] = "verification-pull-request";
    Environment["DEVELOPMENT"] = "development";
    Environment["TEST"] = "test";
})(Environment || (Environment = {}));
//# sourceMappingURL=Environment.js.map